<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Component" class="d-icon d-icon--component" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 8.122 4.812 9.31 6 10.498 7.19 9.31 6 8.122Zm-3.31-3.31L1.503 6l1.189 1.188L3.879 6 2.691 4.812Zm6.62 0L8.12 6l1.19 1.188L10.498 6 9.31 4.812ZM6 1.502 4.812 2.69 6 3.878 7.19 2.69 6 1.502ZM8.19 9.31a1 1 0 0 1-.293.708l-1.189 1.187a1 1 0 0 1-1.414 0l-1.188-1.187a1.002 1.002 0 0 1 0-1.415l1.188-1.189a1 1 0 0 1 1.414 0l1.189 1.189a1 1 0 0 1 .293.707ZM4.879 6a1 1 0 0 1-.226.634l-.067.073-1.188 1.189a1 1 0 0 1-1.341.066l-.073-.066L.795 6.707a1 1 0 0 1 0-1.414l1.189-1.189a1 1 0 0 1 1.414 0l1.188 1.189.067.073A1 1 0 0 1 4.879 6Zm6.62 0a1 1 0 0 1-.294.707l-1.188 1.189a1.001 1.001 0 0 1-1.341.066l-.073-.066-1.189-1.189a1 1 0 0 1 0-1.414l1.189-1.189a1 1 0 0 1 1.414 0l1.188 1.189a1 1 0 0 1 .293.707Zm-3.31-3.31a1 1 0 0 1-.227.634l-.066.073-1.189 1.189a1 1 0 0 1-1.414 0L4.105 3.397a1 1 0 0 1 0-1.414L5.293.795a1 1 0 0 1 1.414 0l1.189 1.188a1 1 0 0 1 .293.707Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconComponent',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
